"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadBusMemberNamingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrcadBusMemberNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, hierarchy) {
        const instanceBusMembers = new Map();
        const instanceDepth = new Map();
        for (const [instance, nets] of group.getNets()) {
            for (const net of nets) {
                for (const wire of net.wires) {
                    const metadata = wire.strategyMetadata?.['bus-member'];
                    if (metadata) {
                        const busMembers = instanceBusMembers.get(instance) ?? [];
                        busMembers.push({
                            name: metadata.memberName,
                            index: metadata.memberIndex,
                        });
                        instanceBusMembers.set(instance, busMembers);
                        instanceDepth.set(instance, instance.path.length);
                    }
                }
            }
        }
        if (instanceBusMembers.size === 0) {
            return undefined;
        }
        const sortedInstances = Array.from(instanceBusMembers.keys()).sort((a, b) => (instanceDepth.get(a) ?? 0) - (instanceDepth.get(b) ?? 0));
        const shallowestInstance = sortedInstances[0];
        const shallowestMembers = instanceBusMembers.get(shallowestInstance) ?? [];
        return shallowestMembers[0].name;
    }
}
exports.OrcadBusMemberNamingRule = OrcadBusMemberNamingRule;
//# sourceMappingURL=OrcadBusMemberNamingRule.js.map